import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MessagesService {

  currentMessage: string = '';
  currentTitle: string = '';

  constructor() { }

  setMessage(message: string) {
    this.currentMessage = message;
  }

  getMessage() {
    return this.currentMessage;
  }

  setTitle(title: string) {
    this.currentTitle = title;
  }
  getTitle() {
    return this.currentTitle;
  }
}
